import events from './events'

const dispatcher = (event = '', data = {}) => {
  events[event](data)
}

export default dispatcher
